<template>
  <div class="catalog-form">
    <h1 id="init">
      <i class="fal fa-arrow-circle-left" @click="onCancel" title="Regresar"></i>
      <span>{{ title }}</span>

      <div class="top-tool-bar flat actions">
        <div class="action" title="Refrescar registro para obtener las últimas actualizaciones" v-if="id && readOnly && hasPermission('roles:read')" @click="sincronizeForm" variant="outline-info"><i class="fal fa-sync"></i> Refrescar</div>
        <div class="action" title="Modificar" v-if="canUpdate" @click="changeEditMode" variant="outline-secondary"><i class="fal fa-file-edit"></i> Modificar</div>
        <div class="action" title="Eliminar" v-if="canDelete" @click="deleteItem" variant="outline-danger"><i class="fal fa-trash-alt"></i> Eliminar</div>
      </div>
    </h1>

    <div class="menu-area hide-md">
      <div class="list-group">
        <a href="#general" class="list-group-item list-group-item-action" aria-current="true">
          Información general
        </a>
        <a href="#permisos" class="list-group-item list-group-item-action" aria-current="true">
          Permisos
        </a>
        <a v-if="id" href="#history" class="list-group-item list-group-item-action" aria-current="true">
          Actualizaciones
        </a>
      </div>
    </div>

    <div class="form-area">
      <b-form @submit.stop.prevent="onSubmit" v-show="!loading">
        <!-- INFORMACION GENERAL -->
        <b-card id="general" header="Información general" class="form-section">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group
              id="input-group-name"
              label="Nombre *"
              label-for="input-name">
                <b-form-input
                  id="input-name"
                  name="input-name"
                  type="text"
                  class="shadow-none"
                  v-model.trim="form.name"
                  v-validate="{ required: true }"
                  :state="validateState('input-name')"
                  aria-describedby="input-name-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-name-feedback">Nombre requerido</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="select-group-domain"
                label="Dominio *"
                label-for="select-domain">
                <b-form-select
                  id="select-domain"
                  class="shadow-none"
                  name="select-domain"
                  v-model.trim="form.domain"
                  :options="domainOptions"
                  v-validate="{ required: true }"
                  :state="form.domain >= -1"
                  aria-describedby="input-domain-feedback"
                  :disabled="readOnly">
                </b-form-select>
                <b-form-invalid-feedback id="input-domain-feedback">Dominio requerido</b-form-invalid-feedback>
                <small class="text-muted"> ID Dominio: {{form.domain}} </small>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="select-group-from-role"
                label="Copiado del rol"
                label-for="select-from-role">
                <b-form-select
                  id="select-from-role"
                  class="shadow-none"
                  name="select-from-role"
                  v-model.trim="form.copyFromRoleId"
                  :disabled="readOnly"
                  @change="inheritRelatedPermissions"
                  :options="copyFromRoleOptions"
                  >
                </b-form-select>
                <small class="text-muted" v-show="form.copyFromRoleId">ID Role: {{form.copyFromRoleId}}</small>
              </b-form-group>
            </div>
            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-sessions"
                label="Sesiones máximas *"
                label-for="input-max-sessions">
                <b-form-input
                  id="input-max-sessions"
                  name="input-max-sessions"
                  type="number"
                  class="shadow-none"
                  v-model.trim="form.maxSessions"
                  v-validate="{ required: true }"
                  :state="validateState('input-max-sessions') && form.maxSessions >= -1"
                  aria-describedby="input-max-sessions-feedback"
                  :disabled="readOnly"
                 >
                </b-form-input>
                <b-form-invalid-feedback id="input-max-sessions-feedback">Sesiones máximas requeridas, mayor o igual a -1</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>
        </b-card>

        <!-- PERMISOS RELACIONADOS -->
        <b-card id="permisos" header="Permisos relacionados" class="form-section">
          <ItemsTable
            v-show="!loadingPermissions"
            :available="!readOnly"
            :itemType="'Permisos'"
            :items="relatedPermissions"
            :mainItemColumns="filterPermission.fieldsPermission"
            :modalItemColumns="filterPermission.fieldsPermission"
            :mainAction="'remove'"
            :allItems="filterPermission.allPermissions"
            :modalSize="'xl'"
            @load-items="callLoadPermissions"
            @update-items="updatePermissions"
            @delete-items="deletePermissions"
            ></ItemsTable>
        </b-card>

        <!-- ACTUALIZACIONES -->
        <b-card id="history" header="Actualizaciones" class="form-section" v-if="id">
          <table class="table table-responsive-md">
            <thead>
              <tr>
                <th scope="col">Evento</th>
                <th scope="col">Usuario</th>
                <th scope="col">Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Creación</td>
                <td>{{ form.creationUser && form.creationUser.name || '---' }}</td>
                <td>{{ creationDate }}</td>
              </tr>
              <tr>
                <td>Actualización</td>
                <td>{{ form.updateUser && form.updateUser.name || '---' }}</td>
                <td>{{ updateDate }}</td>
              </tr>
            </tbody>
          </table>
        </b-card>

        <!-- ACCIONES -->
        <div class="text-right" v-if="!readOnly">
          <b-button class="mr-2" size="lg" @click="onCancel">Cancelar</b-button>
          <b-button type="submit" variant="primary" size="lg" v-if="!readOnly">Guardar Rol</b-button>
        </div>
      </b-form>

      <LoadingMask :active="loading"/>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Permission, PermissionRoleFilters, Role, RoleUpdate, PermissionCatalogFilters, PermissionCatalogGridItem, RoleCatalogGridItem, RoleCatalogFilters } from '@/types/Catalogs'
import cookiesService from '@/services/support/CookiesService'
import LoadingMask from '@/components/generic/LoadingMask.vue'
import ItemsTable from '@/components/generic/ItemsTable.vue'
import { MessageError } from '@/components/generic/MessageHandling.vue'
import catalogsService from '@/services/CatalogsService'
import { PermissionNames } from '@/types/Auth'
import userInfoStore from '@/store/userInfo'
import { PageRequest } from '@/types/Support'
import moment from 'moment'
import DateFormat from '@/services/DateFormat'
import LogService, { ToString } from '@/services/support/LogService'
import config from '@/config'

const GLOBAL_DOMAIN = -1

@Component({
  components: {
    LoadingMask,
    ItemsTable,
    MessageError
  }
})
export default class AdminRoleForm extends Vue {
  @Prop({ required: true, default: 0 })
  id: number

  @Prop({ required: true, default: '' })
  title: string

  @Prop({ required: false, default: false })
  readOnly: boolean

  loading: boolean = false
  loadingPermissions: boolean = false

  form = Role.getIntanceForEdit()
  formUpdated = RoleUpdate.getIntanceForEdit()

  PAGE_SIZE = 500
  backupRole = ''
  /** To work with permission sections */
  filterPermission = new PermissionRoleFilters()
  allPermissions: PermissionCatalogGridItem[] = []
  copyFromRoleOptions: any[] = []
  allBasicRoles: any[] = []
  domainOptions: any[] = []
  creationDate = ''
  updateDate = ''

  async mounted () {
    if (this.id) {
      this.loading = true
      await catalogsService.getRoleById(this.id).then(data => {
        this.form = data
        this.filterPermission.permissionIds = data.permissions.map((perm) => { return perm.id })
        this.filterPermission.totalPermissions = data.permissions.length
        this.creationDate = data.creationDate ? new DateFormat(data.creationDate).toDateTimeString() : '- - / - - / - - - -'
        this.updateDate = data.updateDate ? new DateFormat(data.updateDate).toDateTimeString() : '- - / - - / - - - -'
      }).finally(() => {
        this.generateInheritRoles()
        this.sincronizeFormUpdated(this.form, this.form.permissions.map((perm) => { return perm.id }))
        this.backupRole = JSON.stringify(this.formUpdated)
        this.loading = false
      })
    } else {
      this.generateInheritRoles()
    }
    this.loadDomainOptions()
  }

  /**
   * Load the roles that can inherited into the current role
   */
  generateInheritRoles () {
    this.loadBasicRoles(new PageRequest<RoleCatalogFilters>(this.PAGE_SIZE)).then(() => {
      this.allBasicRoles = this.allBasicRoles.filter((role: Role) => role.domain === -1)
      this.copyFromRoleOptions = this.allBasicRoles
      this.copyFromRoleOptions.unshift({ value: 0, text: '' })
      if (this.form.copyFromRole) {
        let copyFromRoleDefault = this.copyFromRoleOptions.find(role => (role.text === this.form.copyFromRole))
        this.form.copyFromRoleId = copyFromRoleDefault.value
      }
    })
  }

  /** Permissions */

  /**
   * Check if user has 'permission' permission
   * @param permission name to check
   */
  hasPermission (permission: string) {
    return userInfoStore.userInfo.role.permissions.some(it => it.name === permission)
  }

  /**
   * Checks which records user can update
   */
  get canUpdate () {
    return this.id && this.readOnly && this.hasPermission(PermissionNames.ROLES_UPDATE)
  }

  /**
   * Checks which records user can delete
   */
  get canDelete () {
    return this.id && this.readOnly && this.hasPermission(PermissionNames.ROLES_DELETE)
  }

  /**
   * Submits form values to save changes with a PUT/POST request
   */
  onSubmit () {
    this.sincronizeFormUpdated(this.form, this.filterPermission.permissionIds)
    this.$validator.validateAll().then(result => {
      if (result) {
        if (JSON.stringify(this.formUpdated) === this.backupRole) {
          // If there are no changes then return to main grid
          this.onCancel()
          return
        }
        if (this.id) {
          let msgConfirm = `Has realizado cambios en el registro: ${this.form.id} - ${this.form.name}. ¿Estás seguro de guardar los cambios?`
          this.$bvModal.msgBoxConfirm(msgConfirm, {
            title: 'Confirmar acción',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'primary',
            okTitle: 'Confirmar',
            cancelVariant: 'outline-secondary',
            cancelTitle: 'Cancelar',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            hideHeaderClose: false
          }).then((value) => {
            if (value) {
              this.saveRole()
            }
          })
        } else {
          this.saveRole()
        }
      } else {
        this.$bvToast.toast('Revise los campos marcados con error', {
          title: 'Errores en el formulario',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 4500
        })
      }
    })
  }

  /**
   * POST/PUT request to save the form values
   */
  saveRole () {
    this.loading = true
    this.formUpdated.updateDate = new Date()
    catalogsService.saveRole(this.formUpdated).then((response: RoleUpdate) => {
      this.formUpdated.id = response.id
      this.form.id = response.id
      this.$emit('saved', this.form)
    }).catch((error) => {
      let messageValues = {
        title: 'Error al guardar el rol.',
        message: '',
        delay: 10000,
        error: error
      }
      let errorComponent = new MessageError({ propsData: messageValues })
      errorComponent.displayMessage()
    }).finally(() => {
      this.loading = false
    })
  }

  /**
   * Switch to edit mode
   */
  changeEditMode () {
    this.$emit('edit-mode')
  }

  /**
   * Emit event to remove item
   */
  deleteItem () {
    this.$emit('delete-item')
  }

  /**
   * Updates current Role to sincronized extern changes
   */
  sincronizeForm () {
    if (this.id) {
      this.loading = true
      catalogsService.getRoleById(this.id).then(data => {
        this.form = data
        this.filterPermission.permissionIds = data.permissions.map((perm) => { return perm.id })
        this.filterPermission.totalPermissions = data.permissions.length
      }).finally(() => {
        this.sincronizeFormUpdated(this.form, this.form.permissions.map((perm) => { return perm.id }))
        this.backupRole = JSON.stringify(this.formUpdated)
        this.loading = false
      })
    }
  }

  /**
   * Sincronizes 'formUpdated' with 'form' and assign 'permissionIds'
   * @param form - current role being modified
   * @param roleIds - current permission ids
   */
  sincronizeFormUpdated (form: Role, permissionIds: number[]) {
    this.formUpdated.id = form.id
    this.formUpdated.domain = form.domain
    this.formUpdated.name = form.name
    this.formUpdated.maxSessions = form.maxSessions
    this.formUpdated.copyFromRole = form.copyFromRole
    this.formUpdated.permissions = permissionIds
    this.formUpdated.creationDate = form.creationDate
    this.formUpdated.creationUser = form.creationUser
    this.formUpdated.updateUser = form.updateUser
  }

  /**
   * Close form view
   */
  onCancel () {
    this.$emit('close')
  }

  /**
   * Checks if the input field 'ref' is empty or has an error
   * @param ref id field to validate
   */
  validateState (ref: any) {
    const thiz = this as any
    if (
      thiz.veeFields[ref] &&
      (thiz.veeFields[ref].dirty || thiz.veeFields[ref].validated)
    ) {
      return !thiz.veeErrors.has(ref)
    }
    return null
  }

  /**
   * Returns related permissions from form
   */
  get relatedPermissions () {
    let permissions: any[] = []
    permissions = permissions.concat(this.form.permissions)
    if (this.filterPermission.allPermissions.length > 0) {
      this.filterPermission.allPermissions.forEach(element => {
        if (!permissions.find(perm => perm.id === element.id) && this.filterPermission.permissionIds.includes(element.id)) {
          permissions.push(element)
        }
      })
    }
    return permissions
  }

  /**
   * Inherits permissions from role selected
   */
  inheritRelatedPermissions () {
    if (this.form.copyFromRoleId > 0) {
      this.loading = true
      catalogsService.getRoleById(this.form.copyFromRoleId).then((response) => {
        this.filterPermission.permissionIds = response.permissions.map((perm) => { return perm.id })
        this.filterPermission.totalPermissions = response.permissions.length
        this.form.copyFromRole = response.name
        this.form.permissions = response.permissions
      }).finally(() => {
        this.loading = false
      })
    } else if (!this.id) {
      this.filterPermission.permissionIds = []
      this.filterPermission.totalPermissions = 0
      this.form.copyFromRole = ''
      this.form.permissions = []
    }
  }

  /**
   * Call loadPermissions function
   */
  callLoadPermissions () {
    this.filterPermission.allPermissions = []
    const pageRequest = new PageRequest<PermissionCatalogFilters>(this.PAGE_SIZE)
    if (userInfoStore.inRootDomain()) {
      const cookieDomain = cookiesService.get(config.domainIdCookieName)
      if (this.form.domain > GLOBAL_DOMAIN && this.form.domain !== cookieDomain) {
        pageRequest.filters.domain = this.form.domain
      } else {
        pageRequest.filters.domain = cookieDomain
      }
    }
    this.loadPermissions(pageRequest)
  }

  /**
   * Get all permissions available and assign it in 'allPermissions'
   */
  loadPermissions (pageRequest: PageRequest<any>) {
    this.loadingPermissions = true
    catalogsService.getPermissions(pageRequest).then(response => {
      this.filterPermission.allPermissions.push(...response.results.map((perm: Permission): PermissionCatalogGridItem => {
        return this.generatePermissionGrid(perm, new PermissionCatalogGridItem())
      }))
      if (this.filterPermission.allPermissions.length < response.total) {
        pageRequest.page++
        this.loadPermissions(pageRequest)
      }
    }).catch((error) => {
      LogService.error(`Error en la carga de roles: ${ToString(error.response)}`)
      this.loadingPermissions = false
    }).finally(() => {
      this.loadingPermissions = false
    })
  }

  /**
   * Get all role basic records
   * @param pageRequest - configurations to request
   */
  async loadBasicRoles (pageRequest: PageRequest<RoleCatalogFilters>) {
    await catalogsService.getRoles(pageRequest).then(response => {
      this.allBasicRoles.push(...response.results.map((it: Role): any => {
        return { value: it.id, text: it.name, domain: it.domain }
      }))
      if (this.allBasicRoles.length < response.total) {
        pageRequest.page++
        this.loadBasicRoles(pageRequest)
      } else {
        this.loading = false
      }
    }).catch((error) => {
      LogService.error(`Error en la carga de registros de roles básicos: ${ToString(error.response)}`)
      this.loading = false
    })
  }

  /**
   * Domain options that user can select
   */
  loadDomainOptions () {
    let cookieDomainId = parseInt(cookiesService.get(config.domainIdCookieName))
    catalogsService.getDomainById(cookieDomainId).then((response) => {
      this.domainOptions.push({ value: response.id, text: response.name })
    })
    if (!this.id) {
      if (this.hasPermission(PermissionNames.ROLES_CREATE) && userInfoStore.userInfo.domain.name === 'root') {
        this.domainOptions.push({ value: GLOBAL_DOMAIN, text: 'GLOBAL' })
      }
      this.form.domain = cookieDomainId
    } else {
      if (this.form.domain !== cookieDomainId && this.form.domain !== GLOBAL_DOMAIN) {
        catalogsService.getDomainById(this.form.domain).then((domain) => {
          this.domainOptions.push({ value: domain.id, text: domain.name })
        })
      }
      if ((this.hasPermission(PermissionNames.ROLES_CREATE) && userInfoStore.userInfo.domain.name === 'root') || this.form.domain === GLOBAL_DOMAIN) {
        this.domainOptions.push({ value: GLOBAL_DOMAIN, text: 'GLOBAL' })
      }
    }
  }

  /**
   * Create a RoleCatagolGridItem with base on Role
   * @param origin - to obtains values
   * @param target - RoleCatalogGridItem to fill with origin object values
   */
  fillGridItem (origin: Role, target: RoleCatalogGridItem) {
    target.id = origin.id
    target.copyFromRole = origin.copyFromRole
    target.maxSessions = origin.maxSessions
    target.name = origin.name
    target.domain = origin.domain
    target.creation = origin.updateDate ? moment(origin.creationDate).format('DD/MM/YYYY') : '--/--/----'
    target.update = origin.updateDate ? moment(origin.updateDate).format('DD/MM/YYYY') : '--/--/----'
    return target
  }

  /**
   * Updates permission ids on action emited from ItemsTable
   * @param newPermissions that will add
   */
  updatePermissions (newPermissions: number[]) {
    this.filterPermission.permissionIds = this.filterPermission.permissionIds.concat(newPermissions)
    this.formUpdated.permissions = this.filterPermission.permissionIds
    this.formUpdated.permissions = this.filterPermission.allPermissions.filter(perm =>
      this.filterPermission.permissionIds
        .includes(perm.id))
      .map((perm) => { return perm.id })
  }

  /**
   * Remove permssion ids that was selected
   * @param permissions that must remove
   */
  deletePermissions (permissions: number[]) {
    this.filterPermission.permissionIds = this.filterPermission.permissionIds.filter(permId => !permissions.includes(permId))
    this.form.permissions = this.form.permissions.filter(perm => !permissions.includes(perm.id))
  }

  /**
   * Update target role form origin permission
   * @param origin - permission entity to get values
   * @param target - PermissionCatalogGridItem to update
   * @returns a PermissionCatalogGridItem updated
   */
  generatePermissionGrid (origin: Permission, target: PermissionCatalogGridItem) {
    target.id = origin.id
    target.name = origin.name
    target.domain = origin.domain
    target.resource = origin.resource
    target.effect = origin.effect
    target.label = origin.label
    target.version = origin.version
    target.description = origin.description
    target.creation = origin.creationDate ? moment(origin.creationDate).format('DD/MM/YYYY') : '--'
    target.creationUser = origin.creationUser ? origin.creationUser.name : '---'
    target.update = origin.updateDate ? moment(origin.updateDate).format('DD/MM/YYYY') : '--'
    target.updateUser = origin.updateUser ? origin.updateUser.name : '---'
    return target
  }
}
</script>
